import React, { useState } from 'react';
import DoneIcon from '@mui/icons-material/Done';
import { ButtonOne } from '../ButtonOne/ButtonOne.component';
import { useStyles } from './CompleteSampleAssessmentProcess.styles';
import { Prompt, promptType } from '../Prompt/Prompt.component';
import { completeZwoProcess } from '../../services/scoringModel/scoringModel.service';
import { Button } from '@mui/material';
import {
  AssessmentSessionCloseability,
  CloseSampleAssessmentSessionResponse,
} from '../../services/scoringModel/scoringModel.types';
import { AxiosResponse } from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { SampleAssessmentSessionState } from '../../pages/Dashboard/Dashboard.types';
import { assessmentSessionActions } from '../../reducers/assessmentSessionReducer/assessmentSessionSlice';
import { RootState } from '../../store';

interface CompleteSampleAssessmentProcessProps {
  processStatus: AssessmentSessionCloseability;
  onProcessClosed: () => void;
}

export const CompleteSampleAssessmentProcess: React.FC<CompleteSampleAssessmentProcessProps> = ({
  processStatus,
  onProcessClosed,
}) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const assessmentSession = useSelector((state: RootState) => state.assessmentSession.assessmentSession);
  const [processStatusProps, setProcessStatusProps] = useState<AssessmentSessionCloseability>(processStatus);

  const [prompt, setPrompt] = useState<{ isOpen: boolean; type: promptType; mainText: string; promptText: string }>({
    isOpen: false,
    type: 'success',
    mainText: '',
    promptText: '',
  });

  const confirmEndProcess = () => {
    setPrompt({
      isOpen: true,
      type: 'confirmation',
      mainText: `Czy na pewno chcesz zakończyć 
      pracę ZWO?
    `,
      promptText: '',
    });
  };

  const handleOnClick = () => {
    confirmEndProcess();
  };

  const handleSuccess = () => {
    if(assessmentSession) {
      const updatedAssessmentSession = {
        ...assessmentSession,
        sampleAssessmentSessionStateId: SampleAssessmentSessionState.Closed,
      };
      dispatch(assessmentSessionActions.updateAssessmentSession(updatedAssessmentSession));
    }
    setPrompt({ isOpen: true, type: 'success', promptText: '', mainText: 'Praca ZWO została zakończona.' });
    setProcessStatusProps(AssessmentSessionCloseability.ClosedAlready);
    onProcessClosed();
  };

  const handleOnConfirm = () => {
    prompt.type === 'confirmation'
      ? completeZwoProcess()
          .then((res: AxiosResponse<CloseSampleAssessmentSessionResponse>) => {
            res.data === CloseSampleAssessmentSessionResponse.Success
              ? handleSuccess()
              : setPrompt({
                  isOpen: true,
                  type: 'error',
                  promptText: '',
                  mainText: 'Nie można zakończyć pracy ZWO. Spróbuj ponownie później.',
                });
          })
          .catch(() =>
            setPrompt({
              isOpen: true,
              type: 'error',
              promptText: '',
              mainText: 'Nie można zakończyć pracy ZWO. Spróbuj ponownie później.',
            }),
          )
      : setPrompt((prev) => ({ ...prev, isOpen: false }));
  };

  return (
    <>
      {processStatusProps !== AssessmentSessionCloseability.ClosedAlready ? (
        <ButtonOne
          startIcon={processStatus === AssessmentSessionCloseability.CanBeClosed ? <DoneIcon /> : undefined}
          variant="contained"
          className={styles.button}
          disabled={processStatus === AssessmentSessionCloseability.CannotBeClosed}
          onClick={handleOnClick}
        >
          Zakończ pracę ZWO
        </ButtonOne>
      ) : (
        <Button className={styles.alreadyCompleted} disabled={true} startIcon={<DoneIcon />}>
          PRACA ZWO ZAKOŃCZONA
        </Button>
      )}
      <Prompt
        type={prompt.type}
        open={prompt.isOpen}
        mainText={prompt.mainText}
        subTexts={[
          {
            text: prompt.promptText,
          },
        ]}
        isBold={true}
        mainActionButtonText={prompt.type === 'confirmation' ? 'TAK' : 'POWRÓT'}
        onCancel={
          prompt.type === 'confirmation'
            ? () => {
                setPrompt((prev) => ({ ...prev, isOpen: false }));
              }
            : undefined
        }
        onConfirm={handleOnConfirm}
      />
    </>
  );
};
